// extracted by mini-css-extract-plugin
export var banner = "main-banner-module--banner--0a20c";
export var children = "main-banner-module--children--a729e";
export var content = "main-banner-module--content--c3765";
export var dark = "main-banner-module--dark--48a71";
export var img = "main-banner-module--img--f6f1c";
export var imgBox = "main-banner-module--img-box--52c8b";
export var ratio = "main-banner-module--ratio--785d8";
export var subtitle = "main-banner-module--subtitle--33ffa";
export var title = "main-banner-module--title--e9ebe";